import { readCookie } from './common'

const GA_ID = 'G-FDG9ECB11E'
const ADS_ID = 'AW-826806582'
const SMARTLOOK_KEY = 'bbac27e43ef286ccbc1807a1cc565933fcd90d0a'

declare global {
    interface Window {
        gtag?: (...args: unknown[]) => void
        smartlook?: ((...args: unknown[]) => void) & { api?: unknown[] }
    }
}

// Delegate to the global gtag defined in index.html: gtag.js only accepts commands
// pushed as a sloppy-mode arguments object, which a strict-mode module can't produce
function gtag(...args: unknown[]) {
    window.gtag?.(...args)
}

let enabled = false

export function analyticsConsented(): boolean {
    return readCookie('cookiebar') === 'CookieAllowed'
}

export function enableAnalytics() {
    if (enabled) return
    enabled = true
    gtag('consent', 'update', {
        ad_storage: 'granted',
        analytics_storage: 'granted',
    })
    gtag('js', new Date())
    gtag('config', ADS_ID)
    gtag('config', GA_ID, { send_page_view: false })
    trackPageView(window.location.pathname)
    console.log('[cookie on 1]')
}

// send_to is required: the GTM container loads its own GA4 destination on the page,
// which breaks gtag's default event routing, so unrouted events silently vanish.
// cfp_spa_path marks hits sent by this module, distinguishing them from any
// GA hits the GTM container fires; the Playwright analytics tests key on it
export function trackPageView(path: string) {
    if (!enabled) return
    gtag('event', 'page_view', {
        send_to: GA_ID,
        page_location: window.location.origin + path,
        cfp_spa_path: path,
    })
}

// Smartlook: session recording. Gated behind the same cookie consent as GA so
// it never fires before the user accepts the cookie bar. Idempotent — safe to
// call on every page load.
let smartlookLoaded = false

export function enableSmartlook() {
    if (smartlookLoaded) return
    smartlookLoaded = true
    console.log('[cookie on 2]')
    // Vendored verbatim from the Smartlook snippet, in a typed form.
    const s = (window.smartlook = window.smartlook || function (...args: unknown[]) {
        (s.api ||= []).push(args)
    }) as ((...args: unknown[]) => void) & { api?: unknown[] }
    s.api = []
    const script = document.createElement('script')
    script.async = true
    script.type = 'text/javascript'
    script.src = 'https://web-sdk.smartlook.com/recorder.js'
    document.head.appendChild(script)
    window.smartlook!('init', SMARTLOOK_KEY, { region: 'eu' })
}

// Contentsquare (uxa): same opt-in rules as Smartlook. Also idempotent.
let contentsquareLoaded = false

export function enableContentsquare() {
    if (contentsquareLoaded) return
    console.log('[cookie on 3]')
    contentsquareLoaded = true
    const script = document.createElement('script')
    script.defer = true
    script.src = 'https://t.contentsquare.net/uxa/dae5d62cf263a.js'
    document.head.appendChild(script)
}
